<template>
    <card-tile full-width title="Credit Scores" class="mt-3">
        <apex-bar-chart
            :key="$_.get(session, 'id', $uuid.v4())"
            :height="340"
            labelColor="#fff"
            borderColor="#333"
            :average="averages.credit_score.average"
            :data="charts.credit_score.series.data"
            :categories="charts.credit_score.categories"
        ></apex-bar-chart>
    </card-tile>
</template>

<script>
export default {
    name: "credit-scores",
    components: {
        CardTile: () =>
            import("@/components/program/components/Dashboard/CardTile.vue"),
        ApexBarChart: () => import("@/components/lib/Charts/ApexBarChart.vue"),
    },
    props: {
        charts: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
        averages: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
        session: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },
};
</script>

<style lang="scss" scoped>
</style>